<template>
    <div class="row g-3">
        <div class="col-md-2">
            <label for="height" class="form-label small fw-semibold">Visina (cm)</label>
            <input
                v-model.number="height"
                id="height"
                type="number"
                class="form-control"
                name="height"
                required
            />
        </div>
        <div class="col-md-2">
            <label for="weight" class="form-label small fw-semibold">Težina (kg)</label>
            <input
                v-model.number="weight"
                id="weight"
                type="number"
                class="form-control"
                name="weight"
                required
            />
        </div>
        <div class="col-md-2">
            <label for="BMI" class="form-label small fw-semibold">BMI</label>
            <input
                :value="bmiValue"
                id="BMI"
                type="number"
                class="form-control"
                :class="bmiClass"
                name="BMI"
                readonly
            />
            <div v-if="bmiLabel" class="form-text" :class="bmiClass">{{ bmiLabel }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        patientWeight: Number,
        patientHeight: Number
    },
    data() {
        return {
            height: this.patientHeight,
            weight: this.patientWeight,
        }
    },

    computed: {
        bmiValue() {
            if (!this.height || !this.weight || this.height <= 0) return null;
            return (this.weight / (this.height / 100) ** 2).toFixed(2);
        },
        bmiClass() {
            const bmi = parseFloat(this.bmiValue);
            if (!bmi) return '';
            if (bmi < 18.5) return 'text-warning';
            if (bmi < 25)   return 'text-success';
            if (bmi < 30)   return 'text-warning';
            return 'text-danger';
        },
        bmiLabel() {
            const bmi = parseFloat(this.bmiValue);
            if (!bmi) return '';
            if (bmi < 18.5) return 'Pothranjenost';
            if (bmi < 25)   return 'Normalna težina';
            if (bmi < 30)   return 'Prekomjerna težina';
            return 'Pretilost';
        },
    }
}
</script>
